import { render, staticRenderFns } from "./legal-urge-history.vue?vue&type=template&id=943e5cc6&scoped=true"
import script from "./legal-urge-history.vue?vue&type=script&lang=ts"
export * from "./legal-urge-history.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943e5cc6",
  null
  
)

export default component.exports